import * as React from 'react';
import { Link } from 'react-router-dom';
import { Entity, getListRowLink, getRowLabel, isBlank } from 'gossamer-unified';
import { DynamicText } from '../ancillary/DynamicText';
import { useCacheRecord } from '../data/useCacheRecord';
import { ParallelLoad } from '../data/ParallelLoad';

interface UneditableReferenceProps {
  refEntity: Entity<any>;
  suppressLink?: boolean;
  value: string | number | null | undefined;
  linkURL?: (key: string | null) => string | null;
}

export const UneditableReference: React.FC<UneditableReferenceProps> = (props) => {
  const key = isBlank(props.value) ? null : String(props.value);
  const record = useCacheRecord(props.refEntity, key, isBlank(key));
  const label = getRowLabel(props.refEntity, 'Dynamic', record.data);
  const linkURL: string | null =
    props.linkURL?.(key) ||
    (record?.data &&
      props.refEntity.listRowLink &&
      !props.suppressLink &&
      key &&
      getListRowLink(props.refEntity.listRowLink, key));
  const content = <DynamicText text={label} />;
  const wrappedInLink = linkURL ? <Link to={linkURL}>{content}</Link> : content;
  if (isBlank(key)) {
    return null;
  }
  return <ParallelLoad responses={[record]}>{wrappedInLink}</ParallelLoad>;
};
